import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../services';
import { TokenType } from './token.enum';

export function loggingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const authService = inject(AuthenticationService);

    return from(authService.ensureValidSession()).pipe(
        switchMap(() => {
            let headers = req.headers.set(TokenType.API_KEY, authService.getApiKey);
            const authToken = authService.getAuthToken;
            if (authToken) {
                headers = headers.set(TokenType.AUTHORIAZTION, authToken);
            }

            const newReq = req.clone({
                headers: headers,
            });
            return next(newReq);
        })
    );
}